import { cn } from '@/lib/utils';

const SectionTones = {
  paper: 'bg-paper',
  pad: 'bg-pad-light',
};

export function PageSection({ id, titleId, tone = 'paper', focusable = false, children }) {
  return (
    <section
      id={id}
      aria-labelledby={titleId}
      tabIndex={focusable ? -1 : undefined}
      className={cn('section-spacing', SectionTones[tone], focusable && 'outline-none')}
    >
      <div className="section-container">{children}</div>
    </section>
  );
}